<template>
  <div>
    <iModal :title="modelTitle" v-model="showModal" class-name="vertical-center-modal" width="500px"
      :mask-closable="false" @on-cancel="cancel">
      <div class="admin-add">
        <div class="admin-add-content">
          <Form ref="formInline" :model="formInline" :rules="ruleInline" label-position="right" :label-width="100"
            @submit.native.prevent>
            <FormItem label="头像：" prop="avatar">
              <upload ref="uploadAv" :config="avatarConfig" @upload-ok="bannerOK" :fileList="uploadBanner" />
            </FormItem>
            <FormItem label="头衔：" prop="actor">
              <Input v-model="formInline.actor" placeholder="请输入头衔" />
            </FormItem>
            <FormItem label="昵称：" prop="nickname">
              <Input v-model="formInline.nickname" placeholder="请输入昵称" />
            </FormItem>
            <FormItem label="密码：" prop="passwd" v-if="editId">
              <Input v-model="formInline.passwd" placeholder="请输入密码" />
            </FormItem>
            <FormItem label="角色权限：">
              <Checkbox v-model="chatList" :disabled="chatListDisabled">登录后台
              </Checkbox><br />
              <Checkbox v-model="chatList" :disabled="chatListDisabled">开播端登录
              </Checkbox><br />
              <Checkbox v-model="chatList" :disabled="chatListDisabled">连麦
              </Checkbox>
            </FormItem>
          </Form>
        </div>
      </div>
      <div slot="footer">
        <Button type="primary" :loading="loading" @click="handleSubmit('formInline')">确定</Button>
        <Button @click="cancel">取消</Button>
      </div>
    </iModal>
  </div>
</template>

<script>
import upload from "@components/upLoad/upLoad";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "edit-teacher",
  components: {
    upload,
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    options: {
      type: Object,
    },
    modelTitle: {
      type: String,
      default: '编辑讲师'
    }
  },
  data () {
    let that = this;
    const validatePasswd = (rule, value, callback) => {
      if (!that.editId) {
        callback();
      } else {
        if (!value) {
          callback(new Error("请输入密码"));
        } else {
          callback();
        }
      }
    };
    const validateAvatar = (rule, value, callback) => {
      if (that.uploadBanner && that.uploadBanner.length) {
        callback();
      } else {
        callback(new Error("请上传头像"));
      }
    };
    return {
      chatList: true,
      chatListDisabled: true,

      loading: false,
      showModal: false,
      editId: '',
      uploadBanner: [], // 活动图
      formInline: {
        // form双向绑定
        avatar: "",
        actor: "",
        nickname: "",
        passwd: "",
      },
      ruleInline: {
        passwd: [{ required: true, validator: validatePasswd, trigger: "change" }],
        avatar: [{ required: true, validator: validateAvatar, trigger: "change" }],
        actor: [{ required: true, message: "头衔不能为空", trigger: "blur" }],
        nickname: [{ required: true, message: "昵称不能为空", trigger: "blur" }],
      },

      config: {
        fileType: "img",
        headers: {},
        action: "",
        format: ["jpg", "jpeg", "png"],
        "max-size": 2048,
        remind:
          "(请上传 140 x 140 大小的图片，文件大小不超过2M)",
        limitNum: 1
      },
    };
  },
  computed: {
    ...mapGetters({
      uploadUrl: "getUploadUrl",
      formHeaders: "getFormHeaders",
    }),
    avatarConfig () {
      let config = JSON.parse(JSON.stringify(this.config));
      config.id = "uploadAv";
      config.headers = this.formHeaders;
      config.action = this.uploadUrl;
      return config;
    },
    channelId () {
      return this.$route.query.channelId;
    },
  },
  watch: {
    show (val, oldVal) {
      this.showModal = val;
      if (!val) this.$emit("close");
    },
    options (val) {
      if (val.msg) { // 编辑
        if (val.msg.avatar) {
          this.formInline.avatar = val.msg.avatar || '';
          this.uploadBanner = [val.msg.avatar];
        }
        this.formInline.actor = val.msg.actor;
        this.formInline.nickname = val.msg.nickname;
        this.formInline.passwd = val.msg.passwd;
        this.editId = val.msg.id;
      }
    }
  },
  methods: {
    ...mapActions({
      updateTeacher: "liveModule/updateTeacher"
    }),
    bannerOK (list) {
      this.formInline.avatar = list[0];
      this.uploadBanner = list;
    },
    async handleSubmit (name) {
      let form = this.formInline;
      let valid = await this.validForm(name);
      if (!valid) return;
      this.loading = true;
      let logo = this.uploadBanner[0];
      let req = {
        id: this.editId,
        request: {
          channelId: this.channelId,
          nickname: form.nickname,
          actor: form.actor,
          avatar: logo.indexOf('http') !== -1 ? logo : 'https:' + logo,
          passwd: form.passwd,
        }
      };
      let bool = await this.updateTeacher(req).catch(err => {
        this.loading = false;
      });
      this.loading = false;
      if (!bool) {
        this.loading = false;
        this.$Message.error("操作失败，请重新尝试");
      } else {
        this.$emit("finish");
        this.$Message.success("操作成功！");
        this.cancel();
        this.loading = false;
      }
    },
    validForm (name) {
      // 验证表单
      return new Promise((resolve, reject) => {
        this.$refs[name].validate(valid => {
          resolve(valid);
        });
      });
    },
    cancel () {
      this.$refs["formInline"].resetFields();
      this.uploadBanner = []
      this.$emit("close");
    },
  }
};
</script>

<style scoped lang="scss">
.admin-add {
  &-content {
    padding: 20px 40px 20px 20px;
  }
}

.admin-add {
  &-title {
    width: 100%;
    text-align: center;
    margin-bottom: 20px;
    font-size: 16px;
  }

  &-content {
    .submit {
      display: flex;
      justify-content: center;

      button {
        margin-left: -75px;
      }
    }

    img {
      width: 150px;
      height: 150px;
    }
  }

  .form-code-item {
    position: relative;

    .form-code-btn {
      position: absolute;
      right: 1px;
      width: 96px;
      top: 2px;
      border: none;
      outline: none;

      &:focus {
        box-shadow: none;
        border: none;
        outline: none;
      }
    }
  }
}
</style>

